import { Pipe, PipeTransform } from '@angular/core';

import { IGridDeviceAdjustedSize, IPlacedDevice, IRow } from '../models/grid.model';

@Pipe({
    name: 'gridToDeviceSize',
    standalone: false
})
export class GridToDeviceSizePipe implements PipeTransform {

  transform(row: IRow, movingDevices: IPlacedDevice[]): IGridDeviceAdjustedSize {
    // Grids that are adjustable to devices are always adjustable to only one device,
    // so that for we need to select the first one from the segment
    const [movingDevice] = movingDevices;

    if (!row?.adjustedGridToDevices?.length || !movingDevice?.device) {
      return null;
    }
    // eslint-disable-next-line max-len
    const adjustedGrid = row?.adjustedGridToDevices?.find(grid => grid.deviceReference === movingDevice?.device?.reference)

    return adjustedGrid?.gridAdjustedSize || null;
  }

}
